var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallWerke(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.6657C12 12.1757 11.5867 12.589 11.0767 12.589C10.5673 12.589 10.1533 12.1757 10.1533 11.6657V9.51235C10.1533 9.00235 10.5673 8.58901 11.0767 8.58901C11.5867 8.58901 12 9.00235 12 9.51235V11.6657ZM8.92333 11.6657C8.92333 12.1757 8.51 12.589 8 12.589C7.49 12.589 7.07667 12.1757 7.07667 11.6657V9.51235C7.07667 9.00235 7.49 8.58901 8 8.58901C8.51 8.58901 8.92333 9.00235 8.92333 9.51235V11.6657ZM5.84667 11.6657C5.84667 12.1757 5.43267 12.589 4.92333 12.589C4.41333 12.589 4 12.1757 4 11.6657V9.51235C4 9.00235 4.41333 8.58901 4.92333 8.58901C5.43267 8.58901 5.84667 9.00235 5.84667 9.51235V11.6657ZM8 5.25568V3.16768C8 2.63568 7.406 2.31768 6.96333 2.61301L2.594 4.85968C2.22267 5.10701 2 5.52368 2 5.96901V13.2557C2 13.9917 2.59733 14.589 3.33333 14.589H12.6667C13.4027 14.589 14 13.9917 14 13.2557V3.16768C14 2.63568 13.406 2.31768 12.9633 2.61301L8 5.25568Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallWerke);
export default __webpack_public_path__ + "static/media/smallWerke.3a9bb3cb.svg";
export { ForwardRef as ReactComponent };